export default "__VITE_ASSET__C$T8XwoL__"